import React, { useState, useEffect } from "react";

import SearchIcon from "../../../../svgs/search.svg";
import AddCircleIcon from "../../../../svgs/add-circle.svg";
import "./InventoryFilter.scss";
import useDebounce from "../../../../../Shared/GeographyFilters/hooks/useDebounce";

const InventoryFilter = ({
  inventoryNumber,
  setInventoryNumber,
  setShowInventoryCreateModal,
}) => {
  const [localInventoryNumber, setLocalInventoryNumber] =
    useState(inventoryNumber);
  const debouncedInventoryNumber = useDebounce(localInventoryNumber, 400);

  useEffect(() => {
    setInventoryNumber(debouncedInventoryNumber);
  }, [debouncedInventoryNumber, setInventoryNumber]);

  return (
    <div className="filters-section">
      <div className="inventory-number-input">
        <img src={SearchIcon} alt="Search Icon" className="search-icon" />
        <input
          type="text"
          id="inventory-number"
          value={localInventoryNumber}
          onChange={(e) => setLocalInventoryNumber(e.target.value)}
          placeholder="Search"
          className="inventory-input"
        />
      </div>
      <button
        className="create-inventory-btn"
        onClick={() => setShowInventoryCreateModal(true)}
      >
        <img src={AddCircleIcon} alt="Search Icon" className="btn-icon" />
        Add New Inventory Type
      </button>
    </div>
  );
};

export default InventoryFilter;
